<template>
    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <Head :title="$t('orderModifications.update')" />
        <page-title :title="$t('orderModifications.update')"></page-title>
    </div>

    <jet-form-section @submitted="update()">
        <template #form>
            <!-- Card Offer-->
            <form-card
                :title="$t('topics.orderModification')"
                :description="$t('topics.orderModificationDescription')"
            >
                <div class="col-span-6">
                    <label for="title" class="block text-sm font-medium text-gray-700">{{
                        $t("orderModifications.title")
                    }} <RequiredMark /></label>
                    <input
                        type="text"
                        name="title"
                        id="title"
                        v-model="form.updateBase.title"
                        :placeholder="$t('offers.title')"
                        class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                        autofocus
                    />
                    <jet-input-error
                        :message="form.errors['updateBase.title']"
                        class="mt-2"
                    />
                </div>

                <div class="col-span-6">
                    <label
                        for="comment"
                        class="block text-sm font-medium text-gray-700"
                        >{{ $t("orderModifications.comment") }}</label
                    >
                    <div class="flex">
                        <textarea
                            type="textarea"
                            name="description"
                            id="description"
                            v-model="form.updateBase.description"
                            :placeholder="$t('orderModifications.description')"
                            class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                        />
                    </div>
                    <jet-input-error
                        :message="form.errors['updateBase.description']"
                        class="mt-2"
                    />
                </div>
            </form-card>
        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">
                <button
                    @click="cancel"
                    type="button"
                    class="inline-block uppercase font-semibold text-xs tracking-widest"
                >
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                    class="ml-3"
                >
                    {{ $t("actions.save") }}
                </primary-button>
            </div>
        </template>
    </jet-form-section>
</template>

<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import FormCard from "@/Shared/Components/FormCard";
import { Head } from "@inertiajs/inertia-vue3";
import RequiredMark from "@/Shared/Components/RequiredMark";

export default defineComponent({
    props: ["topic", "modification"],
    inheritAttrs: false,
    layout: MainLayout,
    emits: ["closeModal"],
    components: {
        Head,
        PageTitle,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        FormCard,
        RequiredMark,
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        update() {
            this.form.patch(
                this.route("advisors.topics.order-modifications.update", {
                    topic: this.topic.uuid,
                    orderModification: this.modification.uuid,
                }),
                {
                    preserveScroll: true,
                    onSuccess: () =>
                        this.$notify({
                            group: "success",
                            title: "actions.success",
                            text: "orderModifications.updated",
                        }),
                }
            );
        },
    },
    setup(props) {
        const form = useForm({
            updateBase: {
                title: props.modification.title,
                description: props.modification.description,
            },
        });

        return { form };
    },
});
</script>

<style scoped></style>
